export { default as updateUserDetails } from "./updateUserDetails";
